import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
  
  const AccordionBase = ({ id, term, openAccordion, setOpenAccordion }) => {
    const [expanded, setExpanded] = React.useState("panel1");
  
    const handleChange = (userId) => (event, newExpanded) => {
      setExpanded(newExpanded ? userId : false);
      setOpenAccordion(false);
    };
  
    const questionDataArray = [
      {
        id: "accordion#1",
        question: "1. Can I search for anything?",
        answer:
          "We have made searching easy. You can search up anything found in the Location and Accounts tabs. Just type what you're interested in finding into the map search box. As you type, actual search results will appear below the search box, and a counter showing match(s) found. Try combining search strings with “AND” or “OR” to improve your search results. Text strings are usually words but may include letters, numbers, special characters, the dash symbol, or the number sign.",
      },
      {
        id: "accordion#2",
        question: "2. Can I change the map pin colour or icon?",
        answer:
          "Search results are pinned on the map using the system default map marker. You can change the icons and colour of the pins. Click the map marker selector icon next to the search result list to open the colour palette and icon modal. Apply your preferred markers using the Category options.",
      },
      {
        id: "accordion#3",
        question: "3. Can I change my map view?",
        answer:
          "Proximity uses role-based access control (RBAC) for data and features. Your administrator can assign you to a group or groups with the right feature sets and datasets. Go to Admin > Roles & Permissions > User Management, and look for your username to view current access.",
      },
  
      {
        id: "accordion#4",
        question: "4. Why can’t I access the details of the search result?",
        answer:
          "Proximity uses role-based access control (RBAC) for data and features. Your administrator can assign you to a group or groups with the right feature sets and datasets. Go to Admin>Roles & Permissions>User Management, and look for your username to view current access.",
      },
  
      {
        id: "accordion#5",
        question: "5. Can I use Proximity without using the internet?",
        answer:
          "Proximity is a web application; it requires a connection to the Internet. When offline, your database sitting in the cloud will not load.",
      },
      {
        id: "accordion#6",
        question: "6. Can I change the colour of the application?",
        answer:
          "You can change the look and feel of Proximity by clicking on Admin>Settings>Appearance to select the preferred system-wide themed appearance, including colour palette, typography (font) and icons set.",
      },
  
      {
        id: "accordion#7",
        question: "7. Can I rename the fields?",
        answer:
          "Use the Labels feature to rename one or more fields to give fields more meaningful names. Go to Admin > Settings > Labels for fields found in Places/Locations, People, and Services tabs you can rename.",
      },
  
      {
        id: "accordion#8",
        question: "8. What is the difference between basic and advanced search?",
        answer:
          "See the section 1. Can I search for anything? The basic or simple search looks for all the searchable fields in the Places and Accounts tabs. Advanced Search offers more searchable datasets, including People and Services. You can click on the filter icon next to the search box and use Category to narrow search results or expand search combinations.",
      },
  
      {
        id: "accordion#9",
        question: "9. How do I add all my clients onto the map in one go?",
        answer:
          "Data can be ingested (transported from one or more sources) into HiVE through data entry, bulk import, or the published API. Go to Admin > Data Management > Create to add a new Client (or Account), Places/Locations, People, and Services.",
      },
  
      {
        id: "accordion#10",
        question: "10. Can I colour code my different types of clients?",
        answer:
          "See the section on 2. Can I change the map pin colour or icon? Under Category, select your preferred icons and colours to differentiate clients.",
      },
  
      {
        id: "accordion#11",
        question:
          "11. How do I add my first business data? How do I add a new client/place?",
        answer:
          "Data can be ingested (transported from one or more sources) into Proximity through data entry, bulk import, or the published API. Go to Admin > Data Management > Create to add a new Client (or Account), Places/Locations, People, and Services.",
      },
      {
        id: "accordion#12",
        question: "12. Can I compare different places on the dashboard? ",
        answer:
          "The standard Dashboard looks at performance indicators for each location. New features are added to our roadmap periodically. If this feature is valuable to your business, please contact your sales agent, email us at product@sixfactorsolutions.com or get in touch</a> for more detail.",
      },
      {
        id: "accordion#13",
        question: "13. How do I search for two places on the map?",
        answer:
          "To combine the results of two different searches, use “OR” between the text strings, e.g. “Main St” or “Commercial Drive”. For more search options, see the section on 8. What is the difference between simple and advanced search?",
      },
  
      {
        id: "accordion#14",
        question: "14. Can I email someone from Proximity?",
        answer:
          "When you click on an email icon, Proximity will open a new ‘compose window’ with the selected email address in the To: line. Your Default Mail Handler determines the program used to compose messages for your browser.",
      },
  
      {
        id: "accordion#15",
        question: "15. Can I search only in Canada?",
        answer:
          "You can search any record that you have in your database. See the section 1. Can I search for anything?",
      },
  
      {
        id: "accordion#16",
        question: "16. Can I link my CRM or accounting software to the map",
        answer:
          "Proximity can seamlessly interact with your CRM, Accounting, or other systems using its published Application Programming Interface (API). Please contact your sales agent, email us at product@sixfactorsolutions.com or get in touch to sign up for an account. ",
      },
  
      {
        id: "accordion#17",
        question: "17. Can I store photos and documents in Proximity?",
        answer:
          "Proximity uses text hyperlinks (often blue underlined) to connect to resources. Each hyperlink is a URL that can point to HTML files, text files, images, text documents, video and audio files, or anything else that lives on the Web. Proximity will display thumbnails (miniature versions of the actual image) for image files.",
      },
      {
        id: "accordion#18",
        question: "18. Can I log in using my email?",
        answer:
          "You will need a Google Workspace or a Microsoft 365 account to use Proximity. Your system administrator can configure your Cloud Identity in your Google Workspace account to use single sign-on(SSO). For Microsoft 365, the SSO setting is found in Active Directory.",
      },
      {
        id: "accordion#19",
        question: "19. Can I search Google Maps through Proximity?",
        answer:
          "Proximity visualizes your database using the ubiquitous Google Maps. Google Map maintains a separate database. It will require integration work for both databases to work seamlessly. If this feature is valuable to your business, please contact your sales agent, email us at product@sixfactorsolutions.com or get in touch with more detail.",
      },
      {
        id: "accordion#20",
        question: "20. Can I use other web browsers like Safari?",
        answer:
          "For the best experience, always use the latest version of Google Chrome. You’ll have access to the latest features, security and performance. Other web browsers may not be fully tested, and some features may not work, or the application may not run. ",
      },
  
      {
        id: "accordion#21",
        question: "21. Can I update a client’s phone number?",
        answer:
          "You can modify most data, including phone numbers, in Proximity. A pencil icon represents the Edit function, and clicking the icon activates the Edit Mode. You should have the right access to make changes to data. See the section on 4. Why can’t I access the search results?",
      },
  
      {
        id: "accordion#22",
        question: "22. How do I delete a client or location we no longer serve?",
        answer:
          "Proximity archives data that is no longer required, including clients or locations. The Archive action marks the record as “Deleted” and removes the record from view. The data is still kept in your database for audit trail purposes. A trashcan icon represents the Delete function, and selecting the required record followed by the confirmation action will complete this request. You should have the right access to remove data from view. See the section on 4. Why can’t I access the search results?",
      },
  
      {
        id: "accordion#23",
        question: "23. How do I export data from Proximity?",
        answer:
          "Proximity organizes and stores your data as either Master data, Business data, or Audit trails. Export options are available for extracting records into a common file format, e.g. comma-separated value (CSV) supported by Microsoft Excel or Google Sheets, or another database for various data types. Each option launches a wizard that assists you in exporting the data from an existing table or tables into one single file.",
      },
  
      {
        id: "accordion#24",
        question: "24. Can I change the welcome message?",
        answer:
          "First-time users are greeted with a system-wide configurable welcome note. To set or make changes to the welcome message, go to Admin>Settings>Message Template. ",
      },
  
      {
        id: "accordion#25",
        question: "25. I can’t log in.",
        answer:
          "Clear the application cache if you can’t log in to Proximity, although you have a valid and active Google Workspace or Microsoft 365 business account. Check that you are using a supported browser.",
      },
  
      {
        id: "accordion#26",
        question: "26. I need to remove a user.",
        answer:
          'To remove a system user go to Admin>Roles & Permissions>User Management and look for the username. Proximity archives data that is no longer required, including users. The Archive action marks the record as “Deleted” and removes the record from view. The data is still kept in your database for audit trail purposes. Not every contact in your Proximity is a user of the system. You can also remove a contact in Proximity from the People tab. Click on the trashcan icon representing the Delete function, select the required record and confirm your action to complete the request. You must have the right access to remove data from view. See the section on Why can’t I access the search results?',
      },
  
      {
        id: "accordion#27",
        question: "27. Can I get an audit trail of all the changes? ",
        answer: "See the section 23. on Export Audit Trail.",
      },
  
      {
        id: "accordion#28",
        question: "28. Does Proximity have a mobile app?",
        answer:
          "Proximity is a web application available online and can be used on multiple devices. A mobile app can only work on a mobile device. Supported devices include small to large screens, e.g. mobile phones, tablets/laptops, and computers.",
      },
  
      {
        id: "accordion#29",
        question: "29. Can I change the map pin colour or icon?",
        answer:
          "Search results are pinned on the map using the system default map marker. You can change the icons and colour of the pins. Click the map marker selector icon next to the search result list to open the colour palette and icon modal. Apply your preferred markers using the Category options.",
      },
  
      {
        id: "accordion#30",
        question: "30. Where am I?",
        answer:
          "Getting around in Proximity is a breeze. You can either use the back button found on the right of a page or go back to the Map Services by clicking on the map search icon on the Menu Bar. Proximity Site Map gives you an overview of the connectivity between pages.",
      },
    ];
  
    return (
      <div name="questionSection" className="faq-accordion">
        {questionDataArray.map((user, index) => {
          if (user.question.includes(term) === true) {
            if (user.id !== `accordion${id}`) {
              return (
                <Accordion
                  key={index}
                  id={user.id}
                  value={user.id}
                  expanded={expanded === user.id}
                  onChange={handleChange(user.id)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className="faq-accordion__summary"
                  >
                    <Typography className="faq-accordion__heading">
                      {user.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="faq-accordion__details">
                    <Typography>{user.answer}</Typography>
                  </AccordionDetails>
                </Accordion>
              );
            } else {
              return (
                <Accordion
                  key={index}
                  id={user.id}
                  expanded={
                    user.id === `accordion${id}` && openAccordion ? true : false
                  }
                  onClick={() => {
                    setOpenAccordion(!openAccordion);
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className="faq-accordion__summary"
                  >
                    <Typography className="faq-accordion__heading">
                      {user.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="faq-accordion__details">
                    <Typography>{user.answer}</Typography>
                  </AccordionDetails>
                </Accordion>
              );
            }
          } else {
            return null;
          }
        })}
      </div>
    );
  };
  export default AccordionBase;
  
  
